export default {
  methods: {
    goToLogin() {
      this.$store.dispatch('INIT_CHECKOUT');
      this.setAuthType('user');
      this.$router.push(this.i18nLink('login'));
    },
    goToRegistration() {
      this.$store.dispatch('INIT_CHECKOUT');
      this.setAuthType('registration');
      this.$router.push(this.i18nLink('registration'));
    },
    nextStep() {
      this.$store.dispatch('INIT_CHECKOUT');
      this.setAuthType('guest');
      this.$store.dispatch('SET_CHECKOUT_STEP', this.checkoutStep + 1);
    },
    setAuthType(type) {
      let checkout = this.checkout;
      checkout.authType = type;

      this.$store.dispatch('SET_CHECKOUT', checkout);
    }
  },
  created() {
    this.$emit('info', this.$t('auth.login'));
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  },
};
